<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        <div class="text-h4" style="margin-top: 15px;">
            利用プラン変更
        </div>

        <!-- 項目 -->
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-container>
                <v-row>
                    <v-col cols="12" xl="12">
                        <div class="text-h4">
                            企業情報
                        </div>
                    </v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>会社名</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="5">
                        <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="companie.name" :error-messages="errors" background-color="white" placeholder="貴社名をご入力ください"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="5"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>郵便番号</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider name="郵便番号" rules="required|numeric|digits:7" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="companie.zip_code" placeholder="入力すると住所が出力されます" hint="ハイフン無しでご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="6"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>都道府県</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <v-select outlined clearable v-disabled-icon-focus v-model="companie.address_prefecture" :items="prefectures" :error-messages="errors"  background-color="white" placeholder="ご選択ください"></v-select>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>市区町村</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="companie.address_city" :error-messages="errors" background-color="white" placeholder="例：千代田区七番町"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>番地１</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="companie.address_address1" :error-messages="errors" background-color="white" placeholder="例：〇丁目△番地"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>番地２</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="companie.address_address2" :error-messages="errors" background-color="white" placeholder="例：〇△ビル３階"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2"></v-col>

                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>支払方法</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|max:50" v-slot="{ errors }">
                            <v-select outlined v-model="companie.payment_method" :items="paymentMethodList" :error-messages="errors" background-color="white" placeholder="ご選択ください"></v-select>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="7"></v-col>

                    <v-col cols="12" xl="12">
                        <div class="text-h4">
                            請求情報
                        </div>
                    </v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>請求担当者名</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_name" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>部署名</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_department" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="2"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>TEL</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider name="TEL" rules="required|numeric|min:10|max:11" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_tel" placeholder="ハイフン無しでご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="7"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="必　須" color="red">
                            <label-component>メールアドレス</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="required|email|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_email_address_main" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" xl="7"></v-col>
                    <v-col cols="12" xl="2">
                        <badge-component tile content="任　意">
                            <label-component>メールアドレス CC:</label-component>
                        </badge-component>
                    </v-col>
                    <v-col cols="12" xl="3">
                        <ValidationProvider rules="email|max:255" v-slot="{ errors }">
                            <v-text-field outlined clearable v-disabled-icon-focus v-model="invoiceInfo.billing_email_address_sub" :error-messages="errors" background-color="white"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
            </v-container>

            <v-container>
                <v-row class="justify-center">
                    <v-col>
                        <div class="text-h4 text-center text--primary">{{ planInfo.name }} に申し込みます</div>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-col>
                        <div class="text-center text--primary">{{ planInfo.explanation }}</div>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-col>
                        <label-component>詳細はヘルプセンターにご確認ください。</label-component>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row class="justify-center">
                    <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk" :disabled="invalid">
                        <slot name="ok-btn">お申込み</slot>
                    </v-btn>
                </v-row>
            </v-container>
        </ValidationObserver>
    </v-container>
</template>

<script>
    const jsonpAdapter = require('axios-jsonp');
    export default {
        data() {
            return {
                planInfo: {},
                invoiceInfo: {},
                companie: {},
                paymentMethodList: [],
                prefectures: [],
                newPlanId: null,
                // メッセージ
                message: null,
                success: false,
                aid: null,
                sending: false,
            };
        },
        watch: {
            // 住所検索
            'companie.zip_code': function(next, prev) {
                // バリデーションチェック
                const reg = /^\d{7}$/;
                if (!reg.test(next)) return;

               axios({
                    url: `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${next}`,
                    adapter: jsonpAdapter, // requireしたアダプタを利用
                })
                .then((res) => {
                    this.companie.address_prefecture = res.data.results[0].address1; // 都道府県
                    this.companie.address_city = res.data.results[0].address2 + res.data.results[0].address3; // 市区町村
                }).catch(res => {
                    // console.log(res);
                    this.success = false;
                    this.message = "該当する住所が見つかりませんでした";
                }).finally(() => {
                });
            }
        },
        methods: {
            // 更新
            pushOk: async function(tkn) {
                this.sending = true;
                axios.post('/documents/plan-changed', {
                    new_plan_id: this.newPlanId,
                    name: this.companie.name,
                    tel: this.companie.tel,
                    zip_code: this.companie.zip_code,
                    address_prefecture: this.companie.address_prefecture,
                    address_city: this.companie.address_city,
                    address_address1: this.companie.address_address1,
                    address_address2: this.companie.address_address2,
                    payment_method: this.companie.payment_method,
                    billing_name: this.invoiceInfo.billing_name,
                    billing_department: this.invoiceInfo.billing_department,
                    billing_tel: this.invoiceInfo.billing_tel,
                    billing_email_address_main: this.invoiceInfo.billing_email_address_main,
                    billing_email_address_sub: this.invoiceInfo.billing_email_address_sub,
                    token: tkn,
                }).then(res => {
                    this.success = res.data.success;
                    this.message = res.data.message;
                    if (this.success) {
                        // プラン一覧画面に遷移
                        window.location = "/documents/plans";
                    }
                }).catch(res => {
                    this.success = false;
                    this.message = "更新処理に失敗しました";
                }).finally(() => {
                    this.sending = false;
                });
            },
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-planInfo' + location.search).then(res => {
                this.planInfo = res.data.planInfo;
                this.invoiceInfo = res.data.invoiceInfo;
                this.companie = res.data.companie;
                this.prefectures = res.data.prefectures;
                this.paymentMethodList = res.data.paymentMethodList;
                this.newPlanId = res.data.newPlanId;
                this.aid = res.data.aid;
                if (res.data.message) {
                    this.success = false;
                    this.message = res.data.message;
                }
            }).catch(res => {
                this.success = false;
                this.message = "取得処理に失敗しました";
            }).finally(() => {
            });
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .col-12, .col-xl-12 {
        padding: 12px 12px 0 12px;
    }
</style>